export enum BuildingType {
  BoardingHome = 0,
  CaravanMobile = 1,
  Duplex = 2,
  Flat = 3,
  House = 4,
  ManufTransportableHome = 5,
  Storage = 6,
  Townhouse = 7,
  Unit = 8,
  Unknown = 9,
}
